import { z } from 'zod';
import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE } from '../constants.js';
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
/**
 * A boolean arriving as a query-string value.
 *
 * `z.coerce.boolean()` cannot be used for this: it applies JavaScript
 * truthiness, and every non-empty string — including `"false"` — is truthy. A
 * request carrying `?flag=false` was therefore read as `true`, which is the
 * opposite of what the caller asked for.
 */
export const queryBoolean = z
    .union([z.boolean(), z.string()])
    .transform((value) => typeof value === 'boolean' ? value : ['1', 'true', 'yes', 'on'].includes(value.trim().toLowerCase()));
export const uuidSchema = z.string().uuid();
export const idParamSchema = z.object({ id: uuidSchema });
//# sourceMappingURL=common.js.map